<template>
	<div>
		<buttonList :buttonList="list" butWidth="200px" v-if="!isFold"></buttonList>
		<iconList :list="list" v-else></iconList>
		<transfer
			:visible.sync="visible"
			:data="getData"
			v-on="$listeners"
			v-bind="$attrs"
		></transfer>
		<move
			:moveVisible.sync="moveVisible"
			:data="getData"
			v-on="$listeners"
			v-bind="$attrs"
		></move>
		<distribute
			:distributeVisible.sync="distributeVisible"
			:data="getData"
			v-on="$listeners"
			v-bind="$attrs"
		></distribute>
	</div>
</template>
<script>
import iconList from '@/components/chat/components/iconList.vue';
import buttonList from '@/components/chat/buttonList.vue';
import transfer from '@/components/crm/customer/buttonOperation/transfer.vue';
import move from '@/components/crm/customer/buttonOperation/move.vue';
import distribute from '@/components/crm/customer/buttonOperation/distribute.vue';
export default {
	props: {
		isFold: {
			type: Boolean,
			default: false,
		},
		garbageFlag:null,
		getData:null,
	},
	data() {
		return {
			list:[],
			visible:false,
			moveVisible:false,
            distributeVisible:false,
		};
	},
	watch: {
		garbageFlag: {
			handler(val) {
				if (val == 1) {
					this.list = [
						{
							text: '客户分配',
							imgsrc: require('@/assets/chat/cust_trans.png'),
							onClick: () => {
								this.distributeVisible = true;
							},
						},
						{
							text: '客户详情',
							imgsrc: require('@/assets/chat/cust_d.png'),
							onClick: () => {
								this.skip();
							},
						},
					];
				} else {
					this.list = [
						{
							text: '客户转移',
							imgsrc: require('@/assets/chat/cust_trans.png'),
							onClick: () => {
								this.visible = true;
							},
						},
						{
							text: '移入公海',
							imgsrc: require('@/assets/chat/move_high_seas.png'),
							onClick: () => {
								this.moveVisible = true;
							},
						},
						{
							text: '客户详情',
							imgsrc: require('@/assets/chat/cust_d.png'),
							onClick: () => {
								this.skip();
							},
						},
					];
				}
			},
			deep: true,
			immediate: true,
		},
	},
	components: { buttonList, iconList,transfer, move,distribute},
	computed: {},
	methods: {
		skip() {
			if (this.garbageFlag == 1) {
				this.$router.push({
					name: 'publicCustomerDetails',
					query: {
						id: this.getData.customerId,
						type: 2,
					},
				});
			} else {
				this.$router.push({
					name: this.source == 0 ? 'customerDetails_all' : 'customerDetails',
					query: {
						id: this.getData.customerId,
						type: 3,
					},
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
